import { h } from "@stencil/core";
/**
 * The 'ch-tabular-grid-infinite-scroll' provides infinite scroll functionality for a 'ch-tabular-grid' component
 */
export class ChTabularGridInfiniteScroll {
    constructor() {
        this.hasGridScroll = undefined;
        this.status = "loaded";
    }
    gridLayoutElement;
    intersectionGridLayoutObserver;
    intersectionDocumentObserver;
    el;
    /**
     * Event emitted when end is reached.
     */
    infinite;
    componentWillLoad() {
        this.gridLayoutElement = this.el.assignedSlot.closest("section.main");
        this.intersectionGridLayoutObserver = new IntersectionObserver(this.intersectionObserverHandler, {
            root: this.gridLayoutElement,
            rootMargin: "1px"
        });
        this.intersectionGridLayoutObserver.observe(this.el);
        this.intersectionDocumentObserver = new IntersectionObserver(this.intersectionObserverHandler, {
            rootMargin: "1px"
        });
        this.intersectionDocumentObserver.observe(this.el);
    }
    disconnectedCallback() {
        if (this.intersectionGridLayoutObserver) {
            this.intersectionGridLayoutObserver.disconnect();
        }
    }
    /**
     * Indicates that the grid is already loaded.
     */
    async complete() {
        this.status = "loaded";
    }
    intersectionObserverHandler = (entries, observer) => {
        const hasGridScroll = this.gridLayoutElement.scrollHeight !==
            this.gridLayoutElement.clientHeight;
        const emitInfinite = observer.root ? hasGridScroll : !hasGridScroll;
        if (emitInfinite && entries[0].isIntersecting && this.status === "loaded") {
            this.status = "loading";
            this.infinite.emit();
        }
    };
    render() {
        return (h("div", { key: '692f32cf36c12f6a97df563ebd3ad5cbb15a6855', class: "loading", hidden: !(this.status === "loading") }, h("slot", { key: '84614b2618738f1230641fcc483ac1f8db9e471a' })));
    }
    static get is() { return "ch-tabular-grid-infinite-scroll"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["tabular-grid-infinite-scroll.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tabular-grid-infinite-scroll.css"]
        };
    }
    static get properties() {
        return {
            "status": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "TabularGridInfiniteScrollState",
                    "resolved": "\"loaded\" | \"loading\"",
                    "references": {
                        "TabularGridInfiniteScrollState": {
                            "location": "local",
                            "path": "/home/runner/work/chameleon-controls-library/chameleon-controls-library/src/components/tabular-grid/infinite-scroll/tabular-grid-infinite-scroll.tsx",
                            "id": "src/components/tabular-grid/infinite-scroll/tabular-grid-infinite-scroll.tsx::TabularGridInfiniteScrollState"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Indicates whether the grid is loading or already loaded."
                },
                "attribute": "status",
                "reflect": false,
                "defaultValue": "\"loaded\""
            }
        };
    }
    static get states() {
        return {
            "hasGridScroll": {}
        };
    }
    static get events() {
        return [{
                "method": "infinite",
                "name": "infinite",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event emitted when end is reached."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get methods() {
        return {
            "complete": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "Indicates that the grid is already loaded.",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
}
